import { type Directive } from 'vue';
import { useSettingsRAP } from '~/composables/settings/roles-and-permissions';
import {
  AccessMap,
  type TAccess,
  type TCustomPermission,
  type TPermission,
} from '~/composables/settings/roles-and-permissions/AccessEntries';
import { useSettingsUser } from '~/composables/settings/user';

export const vProtect: Directive<HTMLElement, boolean> = {
  mounted(el: HTMLElement, binding) {
    const placeholder = document.createComment('v-protect');
    const parent = placeholder?.parentNode || el.parentNode;
    (el as any)._placeholder = placeholder;

    if (!parent) return;

    if (el.tagName === 'TEMPLATE' && binding.value) {
      parent.replaceChild(placeholder, el);

      const frag = document.createDocumentFragment();
      const children = (el as HTMLTemplateElement).children;
      Array.from(children).forEach((child: Element) => {
        frag.appendChild(child);
      });
      parent.replaceChild(frag, placeholder);
      return;
    }

    if (!binding.value && el.parentNode) {
      el.parentNode.replaceChild(placeholder, el);
    }
  },
  updated(el: HTMLElement, binding) {
    const placeholder: Comment = (el as any)._placeholder;
    const parent = placeholder?.parentNode || el.parentNode;
    if (!parent) return;

    if (el.tagName === 'TEMPLATE' && binding.value) {
      parent.replaceChild(placeholder, el);

      const frag = document.createDocumentFragment();
      const children = (el as HTMLTemplateElement).children;
      Array.from(children).forEach((child: Element) => {
        frag.appendChild(child);
      });
      parent.replaceChild(frag, placeholder);
      return;
    }

    if (!binding.value && el.parentNode) {
      parent.replaceChild(placeholder, el);
    } else if (binding.value && placeholder?.parentNode) {
      parent.replaceChild(el, placeholder);
    }
  },
};

// Just for type safety perposes
export function defRAP(
  acc: TAccess,
  perm: TPermission | TCustomPermission
): boolean {
  if (acc === 'open_to_all') return true;

  // CHECK the visibility of the access
  if (useSettingsUser.isOwner && useSettingsRAP.visibilityList) {
    if (!AccessMap[acc]) return false;
    return useSettingsRAP.visibilityList[AccessMap[acc]] === true;
  }

  const accessEntries = useSettingsRAP.userAccess?.list.filter(
    (a) => a.access === acc
  );
  const hasAccess = accessEntries?.find((a) => a.permission === perm)
    ? true
    : false;
  return hasAccess;
}
